import React, { useEffect, useState } from "react";
import DashboardCard from "./components/DashboardCard";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import UpcommingTable from "./components/UpcommingTable";
import DoctorAppointment from "./components/DoctorAppointment";
import baseUrl from "../../../api/baseUrl";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupIcon from "@mui/icons-material/Group";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import UniquePatientChart from "./components/UniquePatientChart";
import TreatmentPieChart from "./components/TreatmentPieChart";
import TabBar from "../../../components/tabbar/TabBar";

function Dashboard({ subitem }: any) {
  const [theme, setTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark";
    const htmlTheme = document.documentElement.getAttribute("data-theme") as "light" | "dark";
    
    if (savedTheme) {
      setTheme(savedTheme);
    } else if (htmlTheme) {
      setTheme(htmlTheme);
    }

    // Listen for theme changes
    const observer = new MutationObserver(() => {
      const currentTheme = document.documentElement.getAttribute("data-theme") as "light" | "dark";
      if (currentTheme) {
        setTheme(currentTheme);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);
  const [count, setcount] = useState({
    patients: 0,
    lastmonthPatients: 0,
    registerToday: 0,
    appointmentToday: 0,
    appointmentTomorrow: 0,
    cancelledToday: 0,
    cancelledthismonth: 0,
    waittingForConsultant: 0,
  });

  useEffect(() => {
    baseUrl
      .get("dashboard/findPatientsCount")
      .then((response) => {
        setcount({
          ...count,
          patients: response.data.count,
          lastmonthPatients: response.data.lastmonthRegister,
          registerToday: response.data.todayRegister,
          appointmentToday: response.data.appointmentToday,
          appointmentTomorrow: response.data.appointmentTomorrow,
          cancelledToday: response.data.cancelledToday,
          cancelledthismonth: response.data.cancelledthismonth,
          waittingForConsultant: response.data.waittingForConsultant,
        });
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);

  const DASHBOARD_HOME = [
    {
      name: "Total Appointments",
      det: count?.appointmentTomorrow,
      icon: EventNoteIcon,
      color: "amber",
      gradient: "from-amber-400 to-orange-500",
    },
    {
      name: "Total Patients",
      det: count.patients,
      icon: GroupIcon,
      color: "purple",
      gradient: "from-purple-400 to-pink-500",
    },
    {
      name: "Total Treatments",
      det: 0,
      icon: MedicalServicesIcon,
      color: "indigo",
      gradient: "from-indigo-400 to-blue-500",
    },
  ];

  return (
      <div className={`space-y-6 ${theme === "dark" ? "text-slate-200" : ""}`}>
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {DASHBOARD_HOME?.map((item, i) => (
            <DashboardCard
              key={i}
              name={item?.name}
              det={item?.det}
              Icon={item?.icon}
              gradient={item?.gradient}
              theme={theme}
            />
          ))}
        </div>

        {/* Charts Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <UniquePatientChart theme={theme} />
          <TreatmentPieChart theme={theme} />
        </div>

        {/* Tables */}
        <UpcommingTable theme={theme} />
        <DoctorAppointment theme={theme} />
      </div>
  );
}

export default Dashboard;
